<template>
  <div class="col-12">
    <div class=" row text-center m-5">
      <h3 class="ui inverted purple text"><strong> Customer Details</strong></h3>
      <p class="text-muted fw-light mr-4 ml-4">Change the details if the populated information is incorrect.</p>
    </div>
    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-11 col-lg-10">
        <form class="ui form" @submit.prevent="submitForm()">

          <div class="card">
            <div class="card-header">
            </div>
            <div class="card-body">
              <h4 class="ui dividing header">Personal Information</h4>
              <div class="field">
                <div class="fields">
                  <div class="eight wide field">
                    <label>Mobile Number</label>
                    <input type="number" name="mobileNumber" v-model="customer.mobileNumber" disabled
                      placeholder="Mobile Number">
                    <small v-if="errors.phone" class="text-danger">{{ errors.phone }}</small>
                  </div>

                  <div class="eight wide field">
                    <label>Email</label>
                    <input type="text" name="email" v-model="customer.email" placeholder="Email">
                    <small v-if="!isEmailValid" class="text-danger mt-1">
                      The Email is required
                    </small>
                  </div>
                  <div class="eight wide field">
                    <label>Branch</label>
                    <select class="ui fluid dropdown" v-model="customer.branch">
                      <option value="">Select Branch</option>
                      <option v-for="branch of model.branch" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
                    </select>
                    <small v-if="!isBranchValid" class="text-danger mt-1">
                      The Branch is required
                    </small>
                  </div>

                </div>
              </div>
              <div class="field">
                <label>Full Name</label>
                <div class="three fields">
                  <div class="field">
                    <select class="ui fluid dropdown" v-model="customer.title">
                      <option value="">Select Title</option>
                      <option v-for="title of model.title" :key="title.name">{{ title.name }}</option>
                    </select>
                    <small v-if="!isTitleValid" class="text-danger mt-1">
                      The Title is required
                    </small>
                    <small v-if="!isTitleNameValid" class="text-danger mt-1">
                      The Title and Gender are not matching
                    </small>
                  </div>
                  <div class="field">
                    <input type="text" name="firstName" v-model="customer.firstName" placeholder="First Name">
                    <small v-if="!isFirstNameValid" class="text-danger mt-1">
                      The First Name is required
                    </small>
                  </div>
                  <div class="field">
                    <input type="text" name="lastName" v-model="customer.lastName" placeholder="Last Name">
                    <small v-if="!isLastNameValid" class="text-danger mt-1">
                      The Last Name is required
                    </small>
                  </div>
                </div>
              </div>
              <div class="field fluid left icon input mt-4 d-flex flex-column">
                <label>Date Of Birth</label>
                <a-date-picker size="large" v-model:value="customer.dateOfBirth"></a-date-picker>
                <small v-if="!isDOBValid" class="text-danger mt-1">
                  The Date Of Birth is required and should be 18 years and above!
                </small>
              </div>
              <div class="field">
                <div class="fields">
                  <div class="eight wide field">
                    <label>National ID Number</label>
                    <input type="text" name="identityDocNo" v-model="customer.identityDocNo"
                      placeholder="National ID Number">
                    <small v-if="!isIdNumberValid" class="text-danger mt-1">
                      The National ID Number is required
                    </small>
                  </div>

                  <div class="eight wide field">
                    <label>Gender</label>
                    <select class="ui fluid dropdown" v-model="customer.gender">
                      <option value="">Select Gender</option>
                      <option v-for="gender of model.gender" :key="gender.name">{{ gender.name }}</option>
                    </select>
                    <small v-if="!isGenderValid" class="text-danger mt-1">
                      The Gender is required
                    </small>
                    <small v-if="!isTitleNameValid" class="text-danger mt-1">
                      The Title and Gender are not matching
                    </small>
                  </div>

                </div>
              </div>

              <div class="field">
                <div class="fields">
                  <div class="eight wide field">
                    <label>Marital Status</label>
                    <select class="ui fluid dropdown" v-model="customer.maritalStatus">
                      <option value="">Select Marital Status</option>
                      <option v-for="maritalStatus of model.maritalStatus" :key="maritalStatus.name">{{
                          maritalStatus.name
                      }}</option>
                    </select>
                    <small v-if="!isMaritalStatusValid" class="text-danger mt-1">
                      The Marital Status is required
                    </small>
                  </div>

                </div>
              </div>
              <div class="field">
                <label>Address</label>
                <div class="two fields">
                  <div class="field">
                    <input type="text" name="street" v-model="customer.street" placeholder="Street Address">
                    <small v-if="!isStreetValid" class="text-danger mt-1">
                      The Street Address is required
                    </small>
                  </div>
                  <div class="field">
                    <input type="text" name="town" v-model="customer.town" placeholder="Town or City">
                    <small v-if="!isTownValid" class="text-danger mt-1">
                      The Town Or City is required
                    </small>
                  </div>
                </div>
              </div>
              <div class="field">
                <label>Income Details</label>
                <div class="two fields">
                  <div class="field">
                    <input type="text" name="monthlyIncomeAmount" v-model="customer.monthlyIncomeAmount"
                      placeholder="Monthly Income">
                    <small v-if="!isMonthlyIncomeAmountValid" class="text-danger mt-1">
                      The Monthly Income is required
                    </small>
                  </div>
                  <div class="field">
                    <input type="text" name="sourceOfIncome" v-model="customer.sourceOfIncome"
                      placeholder="Source Of Income">
                    <small v-if="!isSourceOfIncomeValid" class="text-danger mt-1">
                      The Source Of Income is required
                    </small>
                  </div>
                </div>
              </div>

              <div class="field">
                <div class="fields">
                  <div class="eight wide field">
                    <label>Activity Expected On The Account</label>
                    <input type="text" name="activityExpectedOnAccount" v-model="customer.activityExpectedOnAccount"
                      placeholder="Activity Expected On The Account">
                    <small v-if="!isActivityExpectedOnAccountValid" class="text-danger mt-1">
                      The Activity Expected On The Account is required
                    </small>
                  </div>

                  <div class="eight wide field">
                    <label>Line Of Business</label>
                    <input type="text" name="lineOfBusiness" v-model="customer.lineOfBusiness"
                      placeholder="Line Of Business">
                    <small v-if="!isLineOfBusinessValid" class="text-danger mt-1">
                      The Line Of Business is required
                    </small>
                  </div>

                </div>
              </div>
            </div>
            <div class="card-footer">
              <button class="ui button  purple fluid mt-4" :disabled="!isFormValid" type="submit">Next</button>
              <button class="ui button  grey fluid mt-4 mb-4" @click="back()">Back</button>

            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import dayjs from "dayjs";
import { useAuthStore } from '@/stores/auth';
import { useCustomerStore } from '@/stores/customer';
import { useAccountOpeningStore } from '@/stores/accountOpening';

export default {
  name: "CurrentCustomerDetails",
  setup() {
    const authStore = useAuthStore();
    const customerStore = useCustomerStore();
    const accountOpeningStore = useAccountOpeningStore();
    return { authStore, customerStore, accountOpeningStore };
  },
  data() {
    return {
      customer: {
        mobileNumber: '',
        title: "",
        firstName: "",
        lastName: "",
        identityDocNo: "",
        gender: "",
        branch: "",
        maritalStatus: "",
        email: "",
        town: "",
        street: "",
        monthlyIncomeAmount: "",
        activityExpectedOnAccount: "",
        sourceOfIncome: "",
        lineOfBusiness: "",
        gotCustomerData: false,
        requestType: "FETCH_CUSTOMER_DETAILS",
        dateOfBirth: null,
      }, accountCreationRequest: {
        mobileNumber: '',
        requestType: "FETCH_CUSTOMER_DETAILS",
      },
      model: {
        gender: [{ name: "MALE" }, { name: "FEMALE" }],
        title: [
          { name: "MR" },
          { name: "MRS" },
          { name: "MISS" },
        ],
        maritalStatus: [{ name: "Single" }, { name: "Married" }, { name: "Widowed" }, { name: "Divorced" }, { name: "Separated" }],
        branch: [
        { id: 1003, name: 'Eastgate' },
        { id: 1004, name: 'Kwame Nkrumah' },
        { id: 1005, name: 'Joina City' },
        { id: 1006, name: 'Avondale' },
        { id: 1007, name: 'Diaspora Banking' },
        { id: 1008, name: 'Mutare' },
        { id: 1009, name: 'Gweru' },
        { id: 1010, name: 'Bulawayo' },
        { id: 1011, name: 'Masvingo' },
        { id: 1012, name: 'Millenial Club' },
        { id: 1013, name: 'Platinum' },
        { id: 1014, name: 'Borrowdale Platinum' },
        { id: 1015, name: 'Victoria Falls' },
        { id: 1016, name: 'Bradfield' }]
      },
      errors: {},
      operations: 0,
    };
  },
  computed: {
    phone() { return this.authStore.phone; },
    user() { return this.authStore.user; },
    storedCurrencyType() { return this.accountOpeningStore.currencyType; },
    isFirstNameValid() {
      return !!this.customer.firstName;
    },
    isLastNameValid() {
      return !!this.customer.lastName;
    },
    isStreetValid() {
      return !!this.customer.street;
    },
    isTownValid() {
      return !!this.customer.town;
    },
    isIdNumberValid() {
      return !!this.customer.identityDocNo && /([0-9]{8,9}[a-z,A-Z][0-9]{2}$)/g.test(this.customer.identityDocNo);
    },
    isEmailValid() {
      return !!this.customer.email && /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.customer.email);
    },
    isGenderValid() {
      return !!this.customer.gender;
    },
    isBranchValid() {
      return !!this.customer.branch;
    },
    isMaritalStatusValid() {
      return !!this.customer.maritalStatus;
    },
    isDOBValid() {
      return !!this.customer.dateOfBirth && dayjs().diff(this.customer.dateOfBirth, 'years') >= 18;
    },
    isTitleValid() {
      return !!this.customer.title;
    },
    isTitleNameValid() {
      if (this.customer.gender === 'MALE') {
        return this.customer.title === 'MR';
      } else if (this.customer.gender === 'FEMALE') {
        return this.customer.title === 'MRS' || this.customer.title === 'MISS';
      } else {
        return false;
      }
    },
    isMonthlyIncomeAmountValid() {
      return !!this.customer.monthlyIncomeAmount;
    },
    isActivityExpectedOnAccountValid() {
      return !!this.customer.activityExpectedOnAccount;
    },
    isSourceOfIncomeValid() {
      return !!this.customer.sourceOfIncome;
    },
    isLineOfBusinessValid() {
      return !!this.customer.lineOfBusiness;
    },
    isFormValid() {
      return (
        this.isFirstNameValid &&
        this.isLastNameValid &&
        this.isTownValid &&
        this.isStreetValid &&
        this.isIdNumberValid &&
        this.isGenderValid &&
        this.isBranchValid &&
        this.isDOBValid &&
        this.isTitleValid &&
        this.isTitleNameValid &&
        this.isMaritalStatusValid &&
        this.isMonthlyIncomeAmountValid &&
        this.isActivityExpectedOnAccountValid &&
        this.isSourceOfIncomeValid &&
        this.isLineOfBusinessValid &&
        this.isEmailValid
      );
    },
  },
  created() {
    // Initialize from Pinia store
    this.customer.mobileNumber = this.phone || this.user?.phone || this.user?.fphone;
    this.accountCreationRequest.mobileNumber = this.phone || this.user?.phone || this.user?.fphone;

    // Pre-populate fields from user data if available
    if (this.user) {
      if (this.user.email) {
        this.customer.email = this.user.email;
      }
      if (this.user.name) {
        this.customer.firstName = this.user.name;
      }
      if (this.user.last_name) {
        this.customer.lastName = this.user.last_name;
      }
      if (this.user.national_id) {
        this.customer.identityDocNo = this.user.national_id;
      }
      if (this.user.gender) {
        this.customer.gender = this.user.gender.toUpperCase();
      }
      if (this.user.title) {
        this.customer.title = this.user.title.toUpperCase();
      }
      if (this.user.dob) {
        this.customer.dateOfBirth = dayjs(this.user.dob);
      }
      if (this.user.address) {
        this.customer.street = this.user.address;
      }
    }
  },
  mounted() {
    this.postNoAuthAndNoBaseUrl(
      URLS.processAccount,
      this.accountCreationRequest,
      "Got Customer Data",
      null,
      true
    ).then((res) => {
      if (!res) return;
      if (res.errors) return (this.errors = res.errors);
      if (res.body.status === "COMPLETE") {
        this.customer.title = res.body.title;
        this.customer.firstName = res.body.firstName;
        this.customer.lastName = res.body.lastName;
        this.customer.identityDocNo = res.body.idNumber;
        this.customer.street = res.body.street;
        this.customer.gender = res.body.gender;
        this.customer.currency = this.storedCurrencyType;
        this.customer.town = res.body.town;
        this.customer.gotCustomerData = true;
        this.customer.dateOfBirth = res.body?.dateOfBirth ? dayjs(res.body.dateOfBirth) : null;
        this.customer.button = "Confirm Your Details";
        this.customer.requestType = "PRE_PROCESS_CURRENT_ACCOUNT";
        this.customer.header = "Please Confirm Your Customer Details";
        // Populate email from API response if available
        if (res.body.email) {
          this.customer.email = res.body.email;
        }
      } else {
        //   this.$router.push("/account-opening/isave-failed");
      }
    });
  },
  methods: {
    back() {
      this.$router.push("/account-opening/currency-type");
    },
    submitForm() {
      if (this.isFormValid) {
        // Save all customer details to Vuex store
        this.setCustomerDetails({
          firstName: this.customer.firstName,
          lastName: this.customer.lastName,
          identityDocNo: this.customer.identityDocNo,
          email: this.customer.email,
          street: this.customer.street,
          currency: this.customer.currency,
          gender: this.customer.gender,
          branch: this.customer.branch,
          maritalStatus: this.customer.maritalStatus,
          title: this.customer.title,
          town: this.customer.town,
          dateOfBirth: dayjs(this.customer.dateOfBirth).format("MM-DD-YYYY"),
          monthlyIncomeAmount: this.customer.monthlyIncomeAmount,
          activityExpectedOnAccount: this.customer.activityExpectedOnAccount,
          sourceOfIncome: this.customer.sourceOfIncome,
          lineOfBusiness: this.customer.lineOfBusiness,
        });
        this.$router.push("/account-opening/signature");
      } else {
        console.log("Error Submitting");
      }
    },
    setCustomerDetails(details) { this.customerStore.setCustomerDetails(details); },
    ...baseMethods,
  },
};
</script>
